import { Assets } from 'pixi.js'
import { Spine } from '@esotericsoftware/spine-pixi-v8'
import { logger } from '../../framework/core/Logger'
import { SYMBOL_NAMES } from '../constants'

// 符號中獎 Spine — 沿用 Unity Animation/Spine/Symbol/ani_*（每個符號一組）。
const BASE = `${import.meta.env.BASE_URL}spine/symbols/`

export async function loadSymbolSpines(): Promise<void> {
  const tasks: Promise<unknown>[] = []
  SYMBOL_NAMES.forEach((name, id) => {
    Assets.add({ alias: `symSkel_${id}`, src: `${BASE}ani_${name}.skel` })
    Assets.add({ alias: `symAtlas_${id}`, src: `${BASE}ani_${name}.atlas` })
    tasks.push(Assets.load([`symSkel_${id}`, `symAtlas_${id}`]))
  })
  await Promise.all(tasks)
}

/** 建立某符號的中獎 Spine 並播放其動畫（迴圈）。失敗回 null。 */
export function createSymbolSpine(id: number): Spine | null {
  try {
    const spine = Spine.from({ skeleton: `symSkel_${id}`, atlas: `symAtlas_${id}` })
    const animations = spine.skeleton.data.animations
    if (animations.length > 0) {
      spine.state.setAnimation(0, animations[0].name, true)
    }
    return spine
  } catch (error) {
    logger.error(`符號 Spine 建立失敗 id=${id}`, error)
    return null
  }
}
